<div class="app-confirmation-events-modal">
  <div class="modal-header">
    <h3 class="modal-title m-0">{{ title }}</h3>
  </div>
  <div class="modal-body">
      <div class="app-confirmation-events-modal__message">{{ prompt }}</div>
  </div>
  <div class="modal-footer">
    <button appButton="outline-secondary" (click)="decline()">No</button>
    <button appButton="primary" (click)="confirm()">Yes</button>
  </div>
</div>
